import { Context, createContext } from "react";
import SocketService from "./socketService";

const socketContext: Context<SocketService> = createContext(
  new SocketService()
);

export default socketContext;
